<script>
export default {

    data() {
        return {
            filteredData: '',
            options: []
        }
    },

    mounted() {
        this.getOptions()
    },

    watch: {
        data() {
            this.filteredData = this.data
        },
        selected() {
            this.filterByTag()
        }
    },

    methods: {
        getOptions() {
            let options = []
            axios.get('/api/taxonomies/'+this.filterProperty+'/terms?filter[site]='+this.site.handle)
                .then(response =>
                    response.data.data.forEach(item =>
                        options.push({label: item.title, value: item.slug})
                    )
                )
            this.options = options;
        },
        filterByTag()
        {   
            if (this.selected == null) {
                this.filteredData = this.data
                return ''
            }
            this.filteredData = this.data.filter(item => item[this.filterProperty].some(itemTag => itemTag.slug == this.selected))
        }
    }

}
</script>
